import { Button, ButtonProps, useDisclosure } from "@chakra-ui/react";
import { lazy, Suspense } from "react";
import useCustomToast from "../../lib/useCustomToast";
import { axiosBuyer } from "../../utils/AxiosInstance";
import { SpinnerLoading } from "../spinner/SpinnerLoading";

const ConfirmationModal = lazy(() => import("../modal/ConfirmationModal"));

interface Props extends ButtonProps {
  orderId: any;
  onRefresh: (type: number) => void;
}

export const ConfirmOrderButton = ({ orderId, onRefresh, ...rest }: Props) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const toast = useCustomToast();

  const confirmOrder = () => {
    axiosBuyer
      .post(`/v1/buyer/confirm-delivered/${orderId}`)
      .then((res) => {
        toast({
          description: res.data.message,
          status: "success",
        });

        onRefresh(1);
        onClose();
      })
      .catch((err) => {
        toast({
          description: err?.response?.data?.message || "",
        });
      })
      .finally(() => {});
  };

  return (
    <>
      <Button
        variant={"outline"}
        colorScheme="red"
        size={["md", null, "sm"]}
        flex={[1, 1, 1, "none", "none"]}
        onClick={onOpen}
        {...rest}
      >
        Pesanan Selesai
      </Button>

      <Suspense fallback={<SpinnerLoading />}>
        <ConfirmationModal
          isOpen={isOpen}
          onOpen={onOpen}
          onClose={onClose}
          title="Konfirmasi Pesanan"
          subtitle="Lakukan konfirmasi jika pesanan anda sudah diterima"
          btnText="Pesanan Diterima"
          onClickSubmit={confirmOrder}
          children={undefined}
        />
      </Suspense>
    </>
  );
};
